import * as D from '@/utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record:{},
     
    },
    getters: {
    },
    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },
    actions: {
        //统计状态
        queryJobStatus(context, payload) {
            return D.select({
                ...payload
            })
        },
        getchartInfo(context, payload) {
            return D.select({
                ...payload
            })
        },
        //查询枚举
        queryEnum(context, payload) {
            return D.select({
                ...payload
            })
        },
        //查询
        queryjobcenter(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 执行一次
        trigger(context, payload) {
            return D.select({
                ...payload
            })
        },

        // 执行器和任务联动
        getJobsByGroup(context, payload) {
            return D.select({
                ...payload
            })
        },

        //注册节点
        loadById(context, payload) {
            return D.select({
                ...payload
            })
        },
        
        //下次执行时间
        nextTriggerTime(context, payload) {
            return D.select({
                ...payload
            })
        },

        //启动
        start(context, payload) {
            return D.select({
                ...payload
            })
        },

        //停止
        stop(context, payload) {
            return D.select({
                ...payload
            })
        },

        //删除
        remove(context, payload) {
            return D.select({
                ...payload
            })
        },

        //新增
        add(context, payload) {
            return D.select({
                ...payload
            })
        },

        //删除
        update(context, payload) {
            return D.select({
                ...payload
            })
        },

        
        //调度日志列表
        loglist(context, payload) {
            return D.select({
                ...payload
            })
        },

        // 终止任务
        logKill(context, payload) {
            return D.select({
                ...payload
            })
        },
        // 详情
        detailjobcenter(context, payload) {
            return D.select({
                ...payload
            })
        },

        // 新增
        addjobcenter(context, payload) {
            return D.add({
                ...payload
            })
        },

        // 编辑
        updatejobcenter(context, payload) {
            return D.edit({
                ...payload
            })
        },

        // 删除
        deletejobcenter(context, payload) {
            return D.del({
                ...payload
            })
        },

        jobgrouplist(context, payload) {
            return D.select({
                ...payload
            })
        },

        removeJobGroup(context, payload) {
            return D.select({
                ...payload
            })
        },

        addJobGroup(context, payload) {
            return D.select({
                ...payload
            })
        },

        editJobGroup(context, payload) {
            return D.select({
                ...payload
            })
        },

        logDetailCat(context, payload) {
            return D.select({
                ...payload
            })
        },
        

    }
}
